import { RollingNumberComponent, RollingNumberOptions } from "./rolling-numbers.component";

interface ViewportStatus {
    top: boolean;
    left: boolean;
    bottom: boolean;
    right: boolean;
    any: boolean;
    all: boolean;
}

export class RollingNumbersService {
    private $currentContext: JQuery = $();
    private rollingNumbersList: Array<RollingNumberComponent> = [];

    public init(context?: JQuery, options?: RollingNumberOptions): void {
        this.$currentContext = context ?? $(document.body);

        this.parseContext(options);
        this.bindEvents();
    }

    private isOutOfWindow(rollingNumber: RollingNumberComponent): ViewportStatus {
        const contextElement = rollingNumber.context.get(0);

        if (!contextElement) {
            return { top: true, left: true, bottom: true, right: true, any: true, all: true };
        }

        const rect = contextElement.getBoundingClientRect();
        const viewport = {
            top: 0,
            left: 0,
            right: window.innerWidth || Number(document.documentElement.clientWidth),
            bottom: window.innerHeight || Number(document.documentElement.clientHeight)
        };

        const out = {
            top: rect.top < viewport.top,
            left: rect.left < viewport.left,
            bottom: rect.bottom > viewport.bottom,
            right: rect.right > viewport.right
        };

        return {
            ...out,
            any: out.top || out.left || out.bottom || out.right,
            all: out.top && out.left && out.bottom && out.right
        };
    }

    private startAnimation(rollingNumber: RollingNumberComponent): void {
        const intervalId = window.setInterval(() => {
            if (rollingNumber.isAnimated) {
                window.clearInterval(intervalId);
                return;
            }

            const isOut = this.isOutOfWindow(rollingNumber);
            if (!isOut.any) {
                try {
                    rollingNumber.animate();
                } catch (e) {
                    console.error("Rolling animation failed", e);
                } finally {
                    window.clearInterval(intervalId);
                }
            }
        }, 100);
    }

    private bindEvents(): void {
        this.rollingNumbersList.forEach((rollingNumber) => {
            this.startAnimation(rollingNumber);

            rollingNumber.on("animation-started", () => {
                const currentId = rollingNumber.id;
                if (!currentId) {
                    return;
                }

                this.rollingNumbersList
                    .filter(entry => entry.id === currentId && rollingNumber !== entry)
                    .forEach(entry => entry.animate());
            });
        });
    }

    private parseContext(options?: RollingNumberOptions): void {
        const $foundElements = $(RollingNumberComponent.SELECTOR, this.$currentContext);

        $foundElements.each((_index, element) => {
            const component = new RollingNumberComponent();
            component.init($(element), options);
            this.rollingNumbersList.push(component);
        });
    }
}
